import { CUSTOM_CLIENT_OFFERS_NAMES } from '../../pages/CustomClientOfferPage/customClientOffersConfig'
import { IOfferState, IPredefinedSingleOfferResponse, IRecalculateOffert, ISubmitChooseOfferData, PredefinedUserOfferObject } from '../types'

export const SET_INITIAL_OFFER = "SET_INITIAL_OFFER";
export const SET_MAX_LOAN_AMOUNT_FOR_MIN_INSTALLMENT = "SET_MAX_LOAN_AMOUNT_FOR_MIN_INSTALLMENT"; 
export const USER_CHANGE_CURRENT_LOAN_AMOUNT = "USER_CHANGE_CURRENT_LOAN_AMOUNT";
export const CHANGE_CURRENT_INSTALLMENT_NUMBER = "CHANGE_CURRENT_INSTALLMENT_NUMBER";
export const RECALCULATE_OFFER = "RECALCULATE_OFFER";
export const SET_CURRENT_CUSTOM_CLIENT_OFFER = "SET_CURRENT_CUSTOM_CLIENT_OFFER";
export const SET_PREDEFINED_USER_OFFERS_ARRAY = "SET_PREDEFINED_USER_OFFERS_ARRAY";
export const SET_PREDEFINED_USER_OFFERS_OBJECT = "SET_PREDEFINED_USER_OFFERS_OBJECT";
export const SET_CURRENT_USER_OFFER_PARAMS = "SET_CURRENT_USER_OFFER_PARAMS";


export interface SetOfferAction {
  type: typeof SET_INITIAL_OFFER;
  payload: IOfferState;
}
export interface ChangeCurrentLoanAmountAction {
  type: typeof USER_CHANGE_CURRENT_LOAN_AMOUNT;
  payload: number
}
export interface ChangeCurrentInstallmentNumberAction {
  type: typeof CHANGE_CURRENT_INSTALLMENT_NUMBER;
  payload: number
}

export interface RecalculateOfferAction {
  type: typeof RECALCULATE_OFFER;
  payload: IRecalculateOffert
}
export interface SetMaxLoanAmountForMinInstallment {
  type: typeof SET_MAX_LOAN_AMOUNT_FOR_MIN_INSTALLMENT;
  payload: number;
}

export  interface ISetCurrentCustomClientOfferAction {
  type: typeof SET_CURRENT_CUSTOM_CLIENT_OFFER;
  payload: CUSTOM_CLIENT_OFFERS_NAMES;
}
export  interface ISetPredefinedUserOffersArrayAction {
  type: typeof SET_PREDEFINED_USER_OFFERS_ARRAY;
  payload: IPredefinedSingleOfferResponse[];
}
export  interface ISetPredefinedUserOffersObjectAction {
  type: typeof SET_PREDEFINED_USER_OFFERS_OBJECT;
  payload: PredefinedUserOfferObject;
}
export  interface ISetCurrentUserOfferParamsAction {
  type: typeof SET_CURRENT_USER_OFFER_PARAMS;
  payload: Omit<ISubmitChooseOfferData, 'offerId'>;
}


export type OfferActions = 
SetOfferAction 
| ChangeCurrentLoanAmountAction
| ChangeCurrentInstallmentNumberAction
| RecalculateOfferAction
| SetMaxLoanAmountForMinInstallment
| ISetCurrentCustomClientOfferAction
| ISetPredefinedUserOffersArrayAction
| ISetPredefinedUserOffersObjectAction
| ISetCurrentUserOfferParamsAction;
